import React, { FC, useState } from "react";
import { Create, CreateProps, FormTab, TabbedForm } from "react-admin";
import { CreditProps } from "../common/generalPickersBlocks/credits/CreditsPickerComponent";
import DiscountAndTickets from "../common/discount/DiscountTickets";
import DocumentTitle from "../common/documentTitle/DocumentTitle";
import PrizeGeneralForm from "./PrizeGeneralForm";
import PrizeToolbar from "./PrizeToolbar";
import { Overview } from "../dreamHome/shared/overview/OverviewBlock";
import { OverviewProvider } from "../dreamHome/shared/overview/OverviewContext";

const PrizeCreate: FC<CreateProps> = (props) => {
  const [datesValue, setDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: new Date("2031-01-18T19:55:00.000+00:00"),
  });
  const [creditDateType, setCreditDateType] = useState<string>("allDate");
  const [overview, setOverview] = useState<Array<Overview>>([]);
  const [overviewError, setOverviewError] = useState(false);
  const handleChangeCreditsDateType = (e: any) => {
    setCreditDateType(e.currentTarget.value);
  };

  const [stateCredits, setCredits] = useState<Array<CreditProps>>([
    {
      id: "1",
      count: 20,
      percent: 30,
    },
  ]);

  const [isActiveCredits, setDoesCreditsActive] = useState<boolean>(false);

  const handleChangeCreditsStatus = () => {
    setDoesCreditsActive(!isActiveCredits);
  };
  const handleSetCredits = (creditsArr: Array<CreditProps>) => {
    setCredits(creditsArr);
  };
  const handleSetDateValue = (value: string, dateName: string) => {
    setDatesValue({
      ...datesValue,
      [dateName]: value,
    });
  };

  const [state, setState] = useState({
    isCash: false,
    isPercent: false,
  });

  const [errors, setError] = useState({
    imagesError: false,
    discountFillError: false,
  });

  const [isDiscountValidate, setIsDiscountValidate] = useState(false);

  const handleDiscountFillError = (error: boolean) => {
    setError({ ...errors, discountFillError: error });
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setState({ ...state, [event.currentTarget.name]: checked });
  };

  const setPercent = () => {
    setState({ ...state, isPercent: false });
  };

  const setCash = () => {
    setState({ ...state, isCash: false });
  };

  const handleImagesError = (error: boolean) => {
    setError({ ...errors, imagesError: error });
  };

  return (
    <>
      <DocumentTitle
        core="Prize"
        secondary="Lifestyle Prizes"
        purpose="Add new"
        appointment="Lifestyle Prize"
      />
      <Create {...props}>
        <TabbedForm
          toolbar={PrizeToolbar(
            props,
            true,
            overview,
            setOverviewError,
            handleImagesError,
            handleDiscountFillError,
            setIsDiscountValidate,
            {
              creditsArr: stateCredits,
              dateType: creditDateType,
              creditsStartDate: datesValue.startDateValue,
              creditsEndDate: datesValue.endDateValue,
              creditsStatus: isActiveCredits,
            }
          )}
          className="general-tab"
        >
          <FormTab label="General">
            <OverviewProvider prizeType="prize">
              <PrizeGeneralForm
                imagesError={errors.imagesError}
                record={undefined}
                isShow={false}
                isPrize={true}
                properties={overview}
                setProperties={setOverview}
                overviewError={overviewError}
              />
            </OverviewProvider>
          </FormTab>
          <FormTab label="Discount & tickets">
            <DiscountAndTickets
              entity={undefined}
              isShow={false}
              ticketPrice={0}
              discountSource="discountCategory"
              isCash={state.isCash}
              isPercent={state.isPercent}
              handleChange={handleChange}
              removePercent={setPercent}
              removeCash={setCash}
              discountFillError={errors.discountFillError}
              isOdds={false}
              isValidate={isDiscountValidate}
              handleChangeCreditsStatus={handleChangeCreditsStatus}
              handleChangeCreditsDateType={handleChangeCreditsDateType}
              handleSetCredits={handleSetCredits}
              isActiveCredits={isActiveCredits}
              credits={stateCredits}
              handleSetDateValue={handleSetDateValue}
              creditDateType={creditDateType}
              creditsStartDateValue={datesValue.startDateValue}
              creditsEndDateValue={datesValue.endDateValue}
              competition="prize"
            />
          </FormTab>
        </TabbedForm>
      </Create>
    </>
  );
};

export default PrizeCreate;
